export const LABEL_FONT_SIZE = 11;
export const LABEL_LINE_HEIGHT = 1.2;
export const MIN_LABEL_FONT_SIZE = 9;
export const LABEL_OFFSET = 4;
export const AXIS_TICK_LABEL_OFFSET = 12;
export const ANIMATION_DURATION = 500;
export const AXIS_TICK_FONT_STYLES = {
  fill: '#4A4A4A',
  fontSize: LABEL_FONT_SIZE,
};
export const TOOLTIP_TIMEOUT = 50;
export const DEFAULT_MARKER_SIZE = 4;
export const DEFAULT_MARKER_STROKE_WIDTH = 2;
export const DEFAULT_MARKER_OPACITY = 1;
